var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93934 10.9393C5.52513 10.3536 6.47487 10.3536 7.06066 10.9393L15 18.8787L22.9393 10.9393C23.5251 10.3536 24.4749 10.3536 25.0607 10.9393C25.6464 11.5251 25.6464 12.4749 25.0607 13.0607L16.0607 22.0607C15.4749 22.6464 14.5251 22.6464 13.9393 22.0607L4.93934 13.0607C4.35355 12.4749 4.35355 11.5251 4.93934 10.9393Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.776e38510a38608de55e47431566e6f0.svg";
export { ForwardRef as ReactComponent };